import { useFontRender } from "@/components/FontRender";
import FormatedText from "@/components/FormatedText";
import { useComponent } from "@/hooks/useMicrositeComponent";
import { cn } from "@/lib/utils";
import { IMicrositeComponent, MComponentTextProps } from "@/types/microsite";
import { useEffect, useMemo, useState } from "react";
import { SpoilerButton } from "./Spoiler";

const TextComponent = {
  kind: "TEXT",
  Render: ({
    microsite,
    id,
    isBuilder,
    isFocus,
    data: {
      textPosition,
      textSize,
      textFont,
      textColor,
      textSizeCustom,
      isSpoiler,
      spoilerButtonColor,
      spoilerButtonTextPosition,
      spoilerButtonText,
      spoilerButtonIcon,
      spoilerButtonFont,
      content: _content,
      passwordMessage,
      needPassword,
    },
  }) => {
    const [{ content }, setData] = useState({
      content: _content,
    });

    const [isOpen, setIsOpen] = useState(false);

    const theContent = useMemo(() => {
      return content
        ? content.replace(/{{micrositename}}/gm, microsite?.slug)
        : "";
    }, [content]);

    const onProtectedOpen = (data) => {
      setData({ content: data.content });
    };

    const { fontStyle, RenderFontStyle } = useFontRender({
      textFont,
      style: { color: textColor ? textColor : undefined },
    });

    useEffect(() => {
      setData({ content: _content });
    }, [_content]);

    return (
      <>
        {RenderFontStyle}
        <SpoilerButton
          spoilerButtonFont={spoilerButtonFont}
          microsite={microsite}
          spoilerButtonColor={spoilerButtonColor}
          spoilerButtonIcon={spoilerButtonIcon}
          spoilerButtonText={spoilerButtonText}
          spoilerButtonTextPosition={spoilerButtonTextPosition}
          isOpen={isOpen}
          onToggle={() => setIsOpen(!isOpen)}
          isBuilder={isBuilder}
          isSpoiler={isSpoiler}
          id={id}
          needPassword={needPassword}
          passwordMessage={passwordMessage}
          onProtectedOpen={onProtectedOpen}
          isFocus={isFocus}
        >
          <TextComponentStyle
            textSize={textSize}
            style={fontStyle}
            textSizeCustom={textSizeCustom as any}
            position={textPosition}
            isSpoiler={isSpoiler}
            id={isBuilder && !isSpoiler ? `mcomp-${id}` : undefined}
            componentId={id}
            isBuilder={isBuilder}
          >
            <FormatedText value={theContent} />
          </TextComponentStyle>
        </SpoilerButton>
      </>
    );
  },
} as IMicrositeComponent<MComponentTextProps>;

export const TextComponentStyle = ({
  position = "",
  textSize = "",
  isSpoiler = false,
  textSizeCustom = undefined,
  style: _style,
  id = "",
  className = "",
  children,
  componentId = "",
  isBuilder = false,
}) => {
  const { focusTo } = useComponent();
  const style = useMemo(() => {
    const style = _style ? { ..._style } : {};
    if (textSize === "custom") {
      style.fontSize = `${
        (textSizeCustom ? parseInt(textSizeCustom) : 16) / 16
      }em`;
    }
    return style;
  }, [_style, textSize, textSizeCustom]);

  return (
    <div
      id={id}
      style={style}
      className={cn(
        "w-full p-2 -my-2 [&>p]:mb-3 [&>p:last-child]:mb-0",
        position === "left" && "text-left",
        position === "center" && "text-center",
        position === "right" && "text-right",
        position === "justify" && "text-justify",
        textSize === "lg" && "text-2xl sm:text-3xl",
        textSize === "sm" && "text-xs sm:text-sm",
        isSpoiler && ["mb-2 rounded-xl py-4 px-4", "!pt-[32px]"],
        className
      )}
      onClick={() => {
        if (componentId && isBuilder) {
          focusTo(componentId);
        }
      }}
    >
      {children}
    </div>
  );
};

export default TextComponent;
